import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import queryString from 'query-string';
import c from 'classnames';
import { Menu } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import {
  Hamburger,
  Container,
  Logo,
} from '../../../components';
import {
  NavigationMainMenuKP,
} from '../..';
import { MENU_KP, APP_OPTIONS } from '../../../config/constants';
import { showNavMenu, hideNavMenu } from '../../../actions/UI';

import './style.scss';

const NavigationFullKP = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchInputRef = useRef(null);
  const { t } = useTranslation();
  const [menuTitle, setMenuTitle] = useState(t('menu'));
  const [active, setActive] = useState(false);
  const params = queryString.parse(window.location.search);
  const paramQueryValue = params[`${APP_OPTIONS.parameters.searchkitIndexAllContentSearch}[query]`];

  const hamburgerClasses = c('Navigation__hamburger', {
    'Navigation__hamburger__opened': active,
  });

  const redirectToSearch = () => {
    history.push({
      pathname: '/zoeken',
      search: `?${encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAllContentSearch}[query]`)}=${searchInputRef.current.value || ''}`,
    });
    setActive(false);
  };

  useEffect(() => {
    if (active) {
      dispatch(showNavMenu());
      setMenuTitle(t('close'));
      document.body.classList.add('noscroll');
    } else {
      dispatch(hideNavMenu());
      setMenuTitle(t('menu'));
      document.body.classList.remove('noscroll');
    }
  }, [active])

  // On page load ensure the current query value is persisted in the input.
  useEffect(() => {
    if (paramQueryValue) {
      searchInputRef.current.value = paramQueryValue;
    }
  }, [paramQueryValue, searchInputRef]);

  return (
    <div className="Navigation__wrapper">
      <div className="Navigation">
        <Container className="Navigation__container">
          <Logo />
          <div className="Navigation__searchbar">
            <div className="Navigation__searchbar__inner">
              <input ref={searchInputRef} type="text" name="search" placeholder={t('kp.search.placeholder')} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  redirectToSearch();
                }
              }} />
              <div className="Navigation__searchbar__icon-holder" onClick={redirectToSearch}>
                <i className="icon icon-search icon-variant-2" />
              </div>
            </div>
          </div>
          <div className={hamburgerClasses} onClick={() => setActive(!active)}>
            <div className="Navigation__title">
              {menuTitle}
            </div>
            <Hamburger icon />
          </div>
        </Container>

        <div className="menu-wrapper">
          <div className="Navigation__menus">
            <div className="Navigation__menus__wrapper">
              <Menu id={MENU_KP}>
                {(items) => {
                  return (
                    <NavigationMainMenuKP
                      items={items}
                      active={active}
                      setActive={setActive}
                    />
                  );
                }}
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavigationFullKP;
